import { Patient } from 'src/models';

const RECENTLY_VIEWED_PATIENTS_KEY = 'recentlyViewedPatients';

export const getRecentlyViewedPatients = ({ orgId }: { orgId: string }) => {
  const recentPatients =
    localStorage.getItem(`${orgId}:${RECENTLY_VIEWED_PATIENTS_KEY}`) || '[]';
  return recentPatients ? JSON.parse(recentPatients) : [];
};

export const addPatientToRecentlyViewed = ({
  orgId,
  patient,
}: {
  orgId: string;
  patient: Patient;
}) => {
  const key = `${orgId}:${RECENTLY_VIEWED_PATIENTS_KEY}`;

  // Add patient to recent visits in localStorage
  const recentPatients: Patient[] = JSON.parse(
    localStorage.getItem(key) || '[]'
  );

  // Remove if patient already exists to avoid duplicates
  const filteredPatients = recentPatients.filter(
    (p: Patient) => p.patient_id !== patient.patient_id
  );

  // Add current patient to front of array
  const updatedPatients = [patient, ...filteredPatients];

  // Keep only 5 most recent
  const limitedPatients = updatedPatients.slice(0, 5);

  localStorage.setItem(key, JSON.stringify(limitedPatients));
};

export const removePatientFromRecentlyViewed = ({
  orgId,
  patientId,
}: {
  orgId: string;
  patientId: number;
}) => {
  const key = `${orgId}:${RECENTLY_VIEWED_PATIENTS_KEY}`;
  const recentPatients: Patient[] = JSON.parse(
    localStorage.getItem(key) || '[]'
  );
  const filteredPatients = recentPatients.filter(
    (p: Patient) => p.patient_id !== patientId
  );
  localStorage.setItem(key, JSON.stringify(filteredPatients));
};
